/**
 * Authenticated LeCoffre API contract for non-OK responses:
 * - **401** — missing or invalid credentials for the resource → callers may run full session teardown.
 * - **403** — authenticated but operation forbidden (RBAC, folder sharing, rule matrix) → never teardown here.
 * - **404** — resource missing (e.g. document-types getByUid) → never teardown / never IdNot logout.
 *
 * Token-refresh endpoints use a separate flow (`SessionRefreshService`); do not merge refresh HTTP semantics into this policy.
 */
export const AUTH_SESSION_FAILURE_LOG_REASON = "Unauthorized - token invalid or expired";

export function isHttpStatusAuthSessionFailure(httpStatus: number): boolean {
	return httpStatus === 401;
}

export function shouldTriggerSessionFailureAfterNonOkResponse(
	httpStatus: number,
	skipSessionFailureOnAuthError?: boolean,
): boolean {
	return isHttpStatusAuthSessionFailure(httpStatus) && !skipSessionFailureOnAuthError;
}
